import { useEffect, useRef } from 'react';
import { buildCSSVars, buildDarkCSSVars } from './buildCSSVars';
import { Theme, ThemeColors } from './theme';
import { buildFontImports, buildTypography } from './buildTypography';

export const CSSVarThemeProvider = ({
    theme,
    global,
    colorOverrides,
}: {
    theme: Theme;
    colorOverrides?: Partial<ThemeColors>;
    global: boolean;
}) => {
    const styleElement = useRef<HTMLStyleElement>();

    useEffect(() => {
        if (!styleElement.current) {
            styleElement.current = document.createElement('style');
            styleElement.current.id = 'rwl-theme';
            document.head.appendChild(styleElement.current);
        }

        // Note to future self.  @imports MUST be at the top of the style element or they quit working
        styleElement.current.innerHTML = `
${buildFontImports(theme)}

:root { 
    ${buildCSSVars(theme, colorOverrides || {})};
    
    transition: color 0.8s ease-in-out, background-color 0.8s ease-in-out;
}

[data-theme="dark"] {
    ${buildDarkCSSVars(theme, colorOverrides || {})};
}

${buildTypography(theme, global)}

`;
    }, [theme, colorOverrides]);

    return null;
};
